import React from 'react';

const Info = ({ action }) => {
  return (
    <div className="w-full text-center md:text-left py-5">
      <h1 
        className="mb-5 underline"
        style={{
          textDecorationStyle: 'wavy',
          textDecorationColor: '#10B981',
        }}
      >
        Cat Generator
      </h1>
      <p className="mb-5 font-light">
        This project will create a randomly generated kitty cat for you. 
      </p>
      <p className="mb-5 font-light">
        This can be useful for those wanting to keep more anonymous online, fancy a change, or simply
        like picutres of cute cats 🐱
      </p>
    </div>
  );
}

export default Info;
